<div class="flex flex-col gap-y-6">
  @if (rows$ | async; as rows) {
  @if (rows.length === 0) {
  <div class="flex flex-col w-full justify-start items-stretch text-center">
    <p class="pt-32">
      <em>No equipment has been added yet.</em>
    </p>
  </div>
  } @else {
  <table mat-table [dataSource]="rows">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="serial_number">
      <th mat-header-cell *matHeaderCellDef>Serial #</th>
      <td mat-cell *matCellDef="let row">{{ row.serial_number }}</td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell *matCellDef="let row">
        {{ row.created_at | amDateFormat: dateFormat }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <a (click)="openEquipmentServiceHistory(row)">
          View workshop history</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
  }
  }
  <div class="flex flex-row justify-center">
    <button mat-flat-button color="primary" (click)="addEquipment()">
      Add Equipment
    </button>
  </div>
</div>